export default __webpack_public_path__ + "static/media/bnr-rzeus-sp.25a5592a.jpg";